import type { AppState } from './types'

// ── Charges vides ────────────────────────────────────────────────────────────
const CHARGES_VIDES = {
  loyer:0,chargesLocatives:0,credit:0,leasingMateriel:0,cfe:0,taxeFonciere:0,
  electricite:0,eau:0,assurance:0,entretien:0,alarme:0,
  fraisKilometriques:0,achatVehicule:0,leasingVehicule:0,essence:0,
  assuranceVehicule:0,transportAchat:0,autresVehicule:0,
  petitMateriel:0,grosMateriel:0,produitsTechniquesCharges:0,
  vetementsProf:0,logicielCoiffure:0,decoration:0,autresMetier:0,
  expertComptable:0,fraisJuridiques:0,honorairesSocial:0,fraisBancaires:0,
  fraisTPE:0,logicielCaisse:0,telephoneFixe:0,telephoneMobile:0,
  hebergementWeb:0,fournitures:0,presse:0,cadeauxClients:0,cotisationsGroupement:0,
  medecine:0,mutuelleSalaries:0,epargneSalariale:0,adsams:0,taxeApprentissage:0,opco:0,
  coaching:0,marketingDigital:0,communication:0,formationCoiffure:0,formationManagement:0,
  sacem:0,spre:0,soustraitance:0,fraisReception:0,autresCharges:0,
}

// ── État vide — utilisé pour les nouveaux salons ET pour la réinitialisation ──
export const DEFAULT_STATE: AppState = {
  salon: { nom: '', ville: '', nbPostes: 0, joursOuverture: 5 },
  charges: CHARGES_VIDES,
  collaborateurs: [],   // aucun collaborateur pré-rempli
  gerant: { coutTotal: 0, heuresMois: 0, tauxEfficacite: 100 },
  parametres: {
    tauxRemplissage: 70,
    pctProduitsTechUtilises: 8,
    objectifBenefice: 0,
    joursTravailles: 22,
    tauxTVA: 20,
    afficherSeuilSansGerant: false,
    modeGerant: 'actif' as const,
  },
}

export const COLLAB_COLORS = ['#1A3C6E','#C62828','#2E7D32','#E65100','#6A1B9A','#00838F']
